import { get, post, del } from './index';

import { IConnection, IEnvironment } from 'models/connection';
import { ICreateConnectionPayload, IConnectionInitialPayload } from 'models/payloads/connections';

export const initiateConnection = (payload: IConnectionInitialPayload) => post<IConnectionInitialPayload, IEnvironment[]>('/my/connections/init', payload, true);
export const getConnections = () => get<IConnection[]>(`/my/connections`, true);
export const createConnection = (payload: ICreateConnectionPayload) => post<ICreateConnectionPayload, IConnection>('/my/connections', payload, true);
export const deleteConnection = (connectionId: string) => del(`/my/connections/${ connectionId }`, true);
